if (!customElements.get('verso-subscription-success')) {
  customElements.define('verso-subscription-success', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      // 隔离 Verso 页对 MainContent 标题的全局覆盖，保持首页弹窗排版。
      document.body.append(this.dialog);
      this.dialog.querySelector('button').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('verso-success-modal-open'));
      // 仅使用 Shopify 返回的成功状态；错误、验证码和网络失败不会触发。
      // 定金模块的订阅弹窗提交成功时由其自己的成功弹窗展示（见 assets/verso-reservation.js），此处跳过
      const handledByReservation = document.documentElement.classList.contains('verso-reserve-subscribed');
      if ((!handledByReservation && document.querySelector('[id^="VersoEmailSuccess--"], [id^="VersoStickySuccess--"]')) || this.dataset.preview === 'true') {
        this.dialog.showModal();
        this.dialog.focus({ preventScroll: true });
        document.documentElement.classList.add('verso-success-modal-open');
        const url = new URL(window.location.href);
        if (url.searchParams.has('customer_posted')) {
          url.searchParams.delete('customer_posted');
          history.replaceState(history.state, '', url);
        }
      }
      this.handleUnload = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
      };
      document.addEventListener('shopify:section:unload', this.handleUnload);
    }

    disconnectedCallback() {
      this.dialog?.close();
      this.dialog?.remove();
      document.removeEventListener('shopify:section:unload', this.handleUnload);
    }
  });
}
